import React from 'react';
import './Screen.scss';
import TimerContainer from "./timer/TimerContainer";
import QuestionNumberContainer from "./questionnumber/QuestionNumberContainer";

const Screen = props => {
  const {selected} = props;
  const choices = ['A', 'B', 'C', 'D'];
  const answers = choices.map((a, key) => <div key={key} className={selected.includes(a) ? 'active' : ''}>{a}</div>);

  return (
    <div className='RemoteScreen'>
      <div className='Question-container'>
        <div>Question</div>
        <QuestionNumberContainer/>
      </div>
      <TimerContainer/>
      <div className='Answers-container'>
        {answers}
      </div>
    </div>
  );
};

export default Screen;
